import { gql } from '@/modes/company/gql';

export const GAUGE_FIELDS = gql(`
  fragment GaugeFields on Gauge {
    id
    gaugeNumber
    calibrationDate
    isDefault
    image {
      contentType
      size
      thumb(size: 350)
      url
    }
  }
`);

export const CREDENTIAL_FIELDS = gql(`
  fragment CredentialFields on Credential {
    id
    type
    issuer
    value
    city
    state
    issueDate
    expireDate
    isDefault
    created
    updated
    image {
      contentType
      size
      thumb(size: 350)
      url
    }
  }
`);

export const ADDRESS_FIELDS = gql(`
  fragment AddressFields on Address {
    id
    street1
    street2
    city
    state
    zip
    zipExt
  }
`);

export const TESTER_PROFILE_FIELDS = gql(
  `
  fragment TesterProfileFields on VendorProfile {
    id
    type
    name
    firstName
    lastName
    phones {
      id
      subType
      value
      extension
    }
    emails {
      id
      subType
      value
    }
    contactAddressId
    contactAddress {
      ...AddressFields
    }
    billingAddressId
    billingAddress {
      ...AddressFields
    }
    backflowTester {
      gauges(where: { archived: null }) {
        ...GaugeFields
      }
    }
    credentials(where: { type: "BACKFLOW", archived: null }) {
      ...CredentialFields
    }
    perms
  }
`,
  [ADDRESS_FIELDS, GAUGE_FIELDS, CREDENTIAL_FIELDS]
);

export const GET_COMPANY_TESTER_DETAIL = gql(
  `
  query GetTesterDetail($where: JSON) {
    vendors(where: $where) {
      id
      accountNumber
      status
      profile {
        ...TesterProfileFields
      }
      user {
        email
      }
      notes
    }
  }
`,
  [TESTER_PROFILE_FIELDS]
);
